import React from "react";
import Theme from "./Theme";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import { Button } from "native-base";

const ArButton = (props) => {
  const {
    children,
    color ,
    iconColor = Theme.COLORS.WHITE,
    variant = "solid",
    icon = null,
    iconLeft = null,
  } = props;
  const ref = React.useRef({});
  // const colorStyle = color && Theme.COLORS[color.toUpperCase()];
  // React.useEffect(() => {
  //   const styleObj = {
  //     backgroundColor: colorStyle,
  //   }; //@ts-ignore

  //   color &&
  //     ref.current.setNativeProps({
  //       style: styleObj,
  //     });
  // }, [ref]);
  const renderIcon = (icon) => {
    return (
      <FontAwesomeIcon
        style={{ marginHorizontal: 3 }}
        icon={icon}
        size={15}
        color={iconColor}
      />
    );
  };
  return (
    <Button
      h={45}
      mb="1.5"
      variant={variant}
      _text={{
        fontSize: 12,
      }}
      ref={ref}
      {...(icon && { leftIcon: renderIcon(icon) })}
      {...(iconLeft && { leftIcon: renderIcon(iconLeft) })}
      {...props}
      colorScheme={color}
    >
      {children}
    </Button>
  );
};

export default ArButton;
